/**
 * Trigger a client-side download of UTF-8 text under a fixed filename, via a transient object URL and
 * anchor click. The shared mechanism behind both the SC2 Preset download (a generated-layout file)
 * and a simple Game Profile's source download (Destiny's cvars.xml) - no backend, the bytes are in
 * the bundle. The text is written verbatim, so a byte-faithful vendored source stays byte-faithful.
 */
export function blobDownload(fileName: string, text: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: "text/plain;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
